/**
 * @generated SignedSource<<a53d96cb54a770d44c7ff03a4ddca5ac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SettingLanguage = "en" | "es" | "fr" | "%future added value";
export type GlobalContextProviderQuery$variables = Record<PropertyKey, never>;
export type GlobalContextProviderQuery$data = {
  readonly entities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly __id: string;
        readonly login: {
          readonly email: string;
        } | null | undefined;
        readonly theme: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly license: {
    readonly chargeAchFeeTo: string | null | undefined;
    readonly checkScanningAccess: {
      readonly noAccess: boolean;
      readonly restrictedAccess: boolean;
    };
    readonly freeTrialLicense: boolean;
    readonly hasLeadAutomationFeature: boolean;
    readonly hasLeadOrganizationFeature: boolean;
    readonly hasUnitPostingsFeature: boolean;
    readonly id: string;
    readonly marketingAccess: {
      readonly noAccess: boolean;
      readonly restrictedAccess: boolean;
    };
    readonly termOverrides: ReadonlyArray<{
      readonly override: string;
      readonly term: string;
    }>;
    readonly timeZone: string;
  };
  readonly setting: {
    readonly language: SettingLanguage | null | undefined;
  };
};
export type GlobalContextProviderQuery = {
  response: GlobalContextProviderQuery$data;
  variables: GlobalContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "returnSelf",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "theme",
  "storageKey": null
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "noAccess",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "restrictedAccess",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "License",
  "kind": "LinkedField",
  "name": "license",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freeTrialLicense",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnitPostingsFeature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLeadOrganizationFeature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLeadAutomationFeature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chargeAchFeeTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TermOverride",
      "kind": "LinkedField",
      "name": "termOverrides",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "term",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "override",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageAccess",
      "kind": "LinkedField",
      "name": "marketingAccess",
      "plural": false,
      "selections": (v6/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageAccess",
      "kind": "LinkedField",
      "name": "checkScanningAccess",
      "plural": false,
      "selections": (v6/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalContextProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EntityConnection",
        "kind": "LinkedField",
        "name": "entities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Login",
                    "kind": "LinkedField",
                    "name": "login",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "entities(returnSelf:true)"
      },
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Setting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GlobalContextProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EntityConnection",
        "kind": "LinkedField",
        "name": "entities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Login",
                    "kind": "LinkedField",
                    "name": "login",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*:: as any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "entities(returnSelf:true)"
      },
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Setting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "979806607a50b58d8f125e4d704046b9",
    "id": null,
    "metadata": {},
    "name": "GlobalContextProviderQuery",
    "operationKind": "query",
    "text": "query GlobalContextProviderQuery {\n  entities(returnSelf: true) {\n    edges {\n      node {\n        __typename\n        login {\n          email\n          id\n        }\n        theme\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  license {\n    id\n    timeZone\n    freeTrialLicense\n    hasUnitPostingsFeature\n    hasLeadOrganizationFeature\n    hasLeadAutomationFeature\n    chargeAchFeeTo\n    termOverrides {\n      term\n      override\n    }\n    marketingAccess {\n      noAccess\n      restrictedAccess\n    }\n    checkScanningAccess {\n      noAccess\n      restrictedAccess\n    }\n  }\n  setting {\n    language\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4c22fdcf4769b030501a85dd7a0178d";

export default node;
